/* eslint-disable @typescript-eslint/naming-convention */
import type { QryBlock } from '@swf/cms';
import { CasinoJoinOperand, CasinoOperand } from '@swf/core/enums';
import type { GameTypesAndVariants } from '@swf/core/types/Notification';

export interface CasinoGameData {
  gameTypes: string[];
  gameTypeToVariants: { [x: number]: string[] | undefined }[];
}

/* eslint-disable no-underscore-dangle */
export const getCasinoGameData = (eligibleGamesList: GameTypesAndVariants[]) => {
  const casinoGameFilters = eligibleGamesList.find((obj) => obj.C)?.C;
  const gameTypes = casinoGameFilters?.filter((obj) => !obj.V_ && obj.T).map((obj) => obj.T) || [];
  const gameTypeToVariants = casinoGameFilters
    ?.filter((type) => type.V_ && type.T)
    .map((type) => ({ [type.T]: type.V_?.map((variant) => variant.V) }));

  return {
    gameTypes,
    gameTypeToVariants
  } as CasinoGameData;
};
/* eslint-enable no-underscore-dangle */

export const getCasinoGamesQuery = (eligibleGamesList: GameTypesAndVariants[]) => {
  const { gameTypes, gameTypeToVariants } = getCasinoGameData(eligibleGamesList);
  const gameTypeQuery: QryBlock = {
    formalparamcode: 'gametype',
    values: gameTypes,
    operand: CasinoOperand.IN,
    join: CasinoJoinOperand.OR,
    dynamic: false,
    exclude_query_values: []
  };

  const gameTypeWithVariantQueries = gameTypeToVariants.map((type) => {
    const [variants] = Object.values(type);
    const [gameType] = Object.keys(type);

    const gameTypeQuery: QryBlock = {
      formalparamcode: 'gametype',
      values: [gameType],
      operand: CasinoOperand.EQ,
      join: CasinoJoinOperand.OR,
      dynamic: false,
      exclude_query_values: []
    };
    const gameVariantQuery: QryBlock = {
      formalparamcode: 'varianttype',
      values: variants ?? [],
      operand: CasinoOperand.IN,
      join: CasinoJoinOperand.OR,
      dynamic: false,
      exclude_query_values: []
    };

    return {
      formalparamcode: '_group',
      values: [gameTypeQuery, gameVariantQuery],
      operand: CasinoOperand.EQ,
      join: CasinoJoinOperand.AND,
      dynamic: false
    };
  });

  return {
    formalparamcode: '_group',
    values: [gameTypeQuery, ...gameTypeWithVariantQueries],
    operand: CasinoOperand.EQ,
    join: CasinoJoinOperand.OR,
    dynamic: false
  };
};
